<template>
  <Card :bordered="!template" :padding="20" :shadow="!template" dis-hover>
    <i-form :model="dados_epico" :rules="rules_validate" label-position="top" ref="dados_epico">
      <form-item prop="name">
        <i-input
          class="nome_projeto"
          placeholder="Nome do Épico"
          size="large"
          v-model="dados_epico.name"
        ></i-input>
      </form-item>
      <Row :gutter="16">
        <i-col span="8">
          <form-item label="Owner" prop="owner">
            <i-select size="large" filterable clearable v-model="dados_epico.owner">
              <i-option
                :key="pessoa.value"
                :value="pessoa.label"
                v-for="pessoa in pessoas"
              >{{ pessoa.label }}</i-option>
            </i-select>
          </form-item>
        </i-col>
        <i-col span="8">
          <form-item label="Squad" prop="squad">
            <i-select size="large" filterable clearable v-model="dados_epico.squad">
              <i-option :key="1" :value="1">Squad 1</i-option>
              <i-option :key="2" :value="2">Squad 2</i-option>
            </i-select>
          </form-item>
        </i-col>
      </Row>
      <form-item label="Descrição" prop="description">
        <vue-editor :editorToolbar="editorToolbar" v-model="dados_epico.description"></vue-editor>
      </form-item>
      <!-- CAMPOS STRATEGY-->
      <h5>1 - Strategy</h5>
      <br />
      <form-item label="1.1 Our Client" prop="ourClient">
        <vue-editor :editorToolbar="editorToolbar" v-model="dados_epico.strategy.ourClient"></vue-editor>
      </form-item>
      <form-item label="1.2 Our Product" prop="ourProduct">
        <vue-editor :editorToolbar="editorToolbar" v-model="dados_epico.strategy.ourProduct"></vue-editor>
      </form-item>

      <!-- CAMPOS CUSTOMER VIEW-->
      <h5>2 - Customer View</h5>
      <br />
      <form-item label="2.1 Customer Problem" prop="customerProblem">
        <vue-editor
          :editorToolbar="editorToolbar"
          v-model="dados_epico.customer_view.customerProblem"
        ></vue-editor>
      </form-item>
      <form-item label="2.2 Target Market" prop="targetMarket">
        <vue-editor :editorToolbar="editorToolbar" v-model="dados_epico.customer_view.targetMarket"></vue-editor>
      </form-item>

      <!-- CAMPO MARKET AND COMPETITORS-->
      <h5>3 - Market and Competitors</h5>
      <br />
      <form-item label="3.1 Competitors" prop="competitors">
        <vue-editor
          :editorToolbar="editorToolbar"
          v-model="dados_epico.market_competitors.competitors"
        ></vue-editor>
      </form-item>
      <!-- CAMPOS HACK AND RELEVANCY-->
      <h5>4 - Hack and Relevancy</h5>
      <br />
      <form-item label="4.1 OKRs" prop="okrs">
        <vue-editor :editorToolbar="editorToolbar" v-model="dados_epico.hack_relevancy.okrs"></vue-editor>
      </form-item>
      <form-item label="4.2 Kpis of Sucess" prop="kpiSucess">
        <vue-editor :editorToolbar="editorToolbar" v-model="dados_epico.hack_relevancy.kpiSucess"></vue-editor>
      </form-item>

      <!-- SELECIONAR OWNER E SQUAD-->
      <Row :gutter="16">
        <i-col span="8">
          <form-item label="Product" prop="product">
            <i-input size="large" placeholder="Ex. Intranet" v-model="dados_epico.product"></i-input>
          </form-item>
        </i-col>
        <i-col span="8">
          <form-item label="Theme" prop="product">
            <i-input size="large" placeholder="Ex. Segurança" v-model="dados_epico.theme"></i-input>
          </form-item>
        </i-col>
      </Row>
    </i-form>
    <div class="floating-btn" v-show="ativar_botao">
      <i-button @click="validar('dados_epico')" icon="md-checkmark" shape="circle" type="primary"></i-button>
    </div>
  </Card>
</template>

<script>
import { find } from "lodash";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import { editorToolbar, moment } from "../../helpers/utils.js";
import treeMixin from "../../mixins/tree";
import { mapGetters } from "vuex";
import axios from "axios";

export default {
  components: {
    VueEditor: () => import("vue2-editor").then(({ VueEditor }) => VueEditor),
    vue2Dropzone: () => import("vue2-dropzone")
  },
  name: "epico",
  props: {
    uuid: [String, Number],
    id: [String, Number],
    template: {
      type: Boolean,
      default: false
    }
  },
  mixins: [treeMixin],
  data() {
    const validatorSelect = (rule, value, callback) => {
      if (value === 0) {
        callback(new Error(rule.message));
      } else {
        callback();
      }
    };
    return {
      unique: 1,
      ativar_botao: false,
      dados_epico: {
        //VARIÁVEIS DOS CAMPOS DOS ÉPICOS
        active: 1,
        name: "",
        owner: "",
        squad: 1,
        strategy: {
          ourClient: "",
          ourProduct: ""
        },
        customer_view: {
          customerProblem: "",
          targetMarket: ""
        },
        market_competitors: {
          competitors: ""
        },
        hack_relevancy: {
          okrs: "",
          kpiSucess: ""
        },
        description: "",
        product: "",
        theme: "",
        list_order: 0,
        create_by: "",
        update_by: ""
      },
      //VALIDAÇÕES DOS CAMPOS
      rules_validate: {
        name: [
          {
            required: true,
            message: "Digite um nome para o épico",
            trigger: "blur"
          }
        ],
        owner: [
          {
            required: true,
            validator: validatorSelect,
            message: "Informe o responsável pelo épico",
            trigger: "change"
          }
        ],
        squad: [
          {
            required: true,
            validator: validatorSelect,
            message: "Escolha o squad do projeto",
            trigger: "change"
          }
        ],
        description: [
          {
            required: true,
            message: "Informe a descrição do Épico.",
            trigger: "blur"
          }
        ]
      },
      tipos_projeto: [],
      modulos: [],
      input_width: "100%",
      editorToolbar
    };
  },
  computed: {
    ...mapGetters(["usuarios"]),
    ...mapGetters(["idUser", "roleUser", "isTester", "currentUser"]),
    pessoas() {
      return this.usuarios.map(item => ({
        value: item.id_pessoa,
        label: item.nome
      }));
    }
  },
  methods: {
    montarDados(dados_epico) {
      if (dados_epico.responsavel_id) {
        dados_epico.responsavel_nome = find(
          this.pessoas,
          o => o.value == dados_epico.responsavel_id
        ).label;
      } else {
        delete dados_epico.responsavel_id;
      }

      if (dados_epico.tipo_projeto_id) {
        dados_epico.tipo_projeto_nome = find(
          this.tipos_projeto,
          o => o.value == dados_epico.tipo_projeto_id
        ).label;
      } else {
        delete dados_epico.tipo_projeto_id;
      }
      if (dados_epico.data_hora_registro) {
        delete dados_epico.data_hora_registro;
      }

      return JSON.parse(JSON.stringify(dados_epico));
    },
    /**
     * Antes de Salvar valida os dados dos inputs
     */
    validar(name) {
      this.$refs[name].validate(valid => {
        if (!valid) {
          this.$Message.error("Há campos não informados!");
        } else {
          this.salvar();
        }
      });
    },
    /**
     * Atualiza um épico existente, ou cria um novo
     */
    async salvar() {
      this.$Spin.show();
      const dados_epico = this.montarDados(this.dados_epico);
      try {
        const uuid = this.uuid;

        const URI = `epico`;
        /**
         * Cria um novo épico
         */
        if (uuid == 0) {
          const { data } = await axios.post(
            `${process.env.VUE_APP_API_URL}${URI}`,
            dados_epico
          );
          this.dados_epico.uuid = data.uuid;
          this.ativar_botao = false;
          this.$Spin.hide();
          this.$Message.success("Épico salvo com sucesso!");
          this.$emit("update", {
            ...data.epic
          });
        } else {
          /**
           * Edita um épico já existente
           */
          let uuid = this.uuid;
          const { data } = await this.$axios.put(
            `${process.env.VUE_APP_API_URL}${URI}/${uuid}`,
            dados_epico
          );
          this.$emit("update", {
            ...data
          });
          this.ativar_botao = false;
          this.$Spin.hide();

          this.$Message.success("Épico editado com sucesso!");
        }
      } catch (error) {
        console.warn(error);
        this.$Message.error(`Erro! ${error}`);
        this.$Spin.hide();
      }
    },

    async getTreeModules() {
      this.modulos = await this.getChildren(1);
    },
    /**
     * Busca os dados do épico para edição
     */
    async getProjeto(id) {
      try {
        let response = await this.$axios.get(`epico/${id}`);

        this.dados_epico.create_by = response.data.create_by;
        this.dados_epico.id = response.data.id;
        this.dados_epico.name = response.data.name;
        this.dados_epico.uuid = response.data.uuid;
        this.dados_epico.description = response.data.description;
        this.dados_epico.owner = response.data.owner;
        this.dados_epico.squad = response.data.squad;
        this.dados_epico.strategy.ourClient = response.data.strategy.ourClient;
        this.dados_epico.strategy.ourProduct =
          response.data.strategy.ourProduct;
        this.dados_epico.customer_view.customerProblem =
          response.data.customer_view.customerProblem;
        this.dados_epico.customer_view.targetMarket =
          response.data.customer_view.targetMarket;
        this.dados_epico.market_competitors.competitors =
          response.data.market_competitors.competitors;
        this.dados_epico.hack_relevancy.okrs =
          response.data.hack_relevancy.okrs;
        this.dados_epico.hack_relevancy.kpiSucess =
          response.data.hack_relevancy.kpiSucess;
        this.dados_epico.product = response.data.product;
        this.dados_epico.theme = response.data.theme;
        this.dados_epico.list_order = response.data.list_order;
        setTimeout(() => {
          this.ativar_botao = false;
        }, 100);
        this.$Spin.hide();
      } catch (error) {
        console.warn(error);
        this.$Spin.hide();
      }
    }
  },
  created() {
    /**
     * Popula os selects do formulário
     */
    this.getTreeModules();
    this.dados_epico.create_by = this.currentUser.nome;
    this.dados_epico.update_by = this.currentUser.nome;
    /**
     * Caso tenha um id nas props consulto os dados do projeto [edição];
     */
    if (this.uuid != null) {
      this.$Spin.show();
      this.getProjeto(this.uuid);
    } else {
      setTimeout(() => {
        this.ativar_botao = false;
      }, 100);
    }
  },
  watch: {
    /**
     * Observa alterações nos dados do projeto
     */
    dados_epico: {
      handler() {
        this.ativar_botao = true;
      },
      deep: true
    }
  }
};
</script>

<style scoped>
.card-add {
  min-height: 916px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  vertical-align: middle;
  margin: 10px 0px;
  text-align: center;
  border: 2px dashed #dcdee2;
  cursor: pointer;
}
.p {
  font-size: 30;
}
</style>
